/* PIRANGA product page: only the selected colour's photos (all sizes); scrolling photo stack on desktop; counter, caption, expand and loop on the mobile/tablet gallery; sticky Add to Cart bar. */
(function () {
  var mq = window.matchMedia('(max-width: 991px)');
  function $(s, r) { return (r || document).querySelector(s); }

  /* ---------- only the selected colour's photos ---------- */
  // A photo's colour comes from its alt text, else the variant that uses it, else the photo before it; with nothing linked at all, an even split. Null when a product's colours cannot be told apart.
  function photoColours() {
    var pj = $('script[id^="ProductJson-"]');
    var product = null;
    try { product = pj ? JSON.parse(pj.textContent) : null; } catch (e) {}
    if (!product || !product.media) return null;
    var pos = -1;
    (product.options || []).forEach(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      if (pos < 0 && /colou?r/i.test(name)) pos = i;
    });
    if (pos < 0) return null;
    var values = {}, byVariant = {};
    product.variants.forEach(function (v) {
      values[v.options[pos]] = true;
      if (v.featured_media && !byVariant[v.featured_media.id]) byVariant[v.featured_media.id] = v.options[pos];
    });
    var media = {}, last = null, first = null, found = {};
    product.media.forEach(function (m) {
      var alt = (m.alt || '').trim();
      var colour = values[alt] ? alt : byVariant[m.id];
      if (colour) { found[colour] = true; last = colour; first = first || colour; }
      media[m.id] = last;
    });
    var names = Object.keys(values);
    if (!Object.keys(found).length && names.length > 1 && product.media.length % names.length === 0) {
      // no photo is linked: photos are taken as uploaded colour by colour, in the order of the colour option
      var per = product.media.length / names.length;
      product.media.forEach(function (m, i) { media[m.id] = names[Math.floor(i / per)]; });
      return { option: 'option' + (pos + 1), media: media };
    }
    if (Object.keys(found).length < 2) return null;
    Object.keys(media).forEach(function (id) { if (!media[id]) media[id] = first; });
    return { option: 'option' + (pos + 1), media: media };
  }
  function selectedColour(colours) {
    var input = $('form.piranga-guarded-form input[name="' + colours.option + '"]:checked');
    return input ? input.value : null;
  }
  function photoColour(colours, item) {
    var el = item.querySelector('[data-media-id]');
    var id = el ? (el.getAttribute('data-media-id').match(/(\d+)$/) || [])[1] : null;
    return id ? colours.media[id] : null;
  }
  // Which of the slides to show; every slide when this colour has no photos of its own, so a gallery is never empty.
  function colourFlags(colours, slides, colour) {
    var flags = slides.map(function (item) { return photoColour(colours, item) === colour; });
    return flags.indexOf(true) < 0 ? slides.map(function () { return true; }) : flags;
  }
  function filterZoom(host, flags) {
    var zoom = host && host.querySelector('zoom-dialog');
    if (!zoom) return;
    [zoom.querySelectorAll('.media-dialog .product-media-container'), zoom.querySelectorAll('.thumbnails-dialog button')].forEach(function (list) {
      Array.prototype.forEach.call(list, function (el, i) { el.classList.toggle('piranga-off', !flags[i]); });
    });
  }
  function onColourChange(colours, run) {
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === colours.option) setTimeout(run, 0);
    });
  }

  // desktop: the photos shown for the chosen colour run one to a line under 6; from 6 up the first and last are full and the rest run two to a line, with any odd one full
  function twoUp(group) {
    var photos = Array.prototype.slice.call(group.querySelectorAll('.js-product-media-item:not(.piranga-off)'));
    var on = photos.length >= 6;
    group.classList.toggle('piranga-two-up', on);
    photos.forEach(function (p, i) {
      var n = photos.length;
      p.classList.toggle('piranga-wide', on && (i === 0 || i === n - 1 || (n % 2 === 1 && i === n - 2)));
    });
  }

  // desktop: the scrolling photo stack
  function initDesktopColours() {
    if (!document.documentElement.classList.contains('piranga-stack-gallery')) return;
    var group = $('.main_pro_class .js-product-media-group');
    var colours = photoColours();
    if (group) twoUp(group);
    if (!group || !colours || group.getAttribute('data-pi-colours')) return;
    group.setAttribute('data-pi-colours', '1');
    var host = group.closest('.product-single__main-media');
    var slides = Array.prototype.slice.call(group.querySelectorAll('.js-product-media-item'));
    var applied = null;
    function apply() {
      var colour = selectedColour(colours);
      if (!colour || colour === applied) return;
      var first = applied === null;
      applied = colour;
      var flags = colourFlags(colours, slides, colour);
      slides.forEach(function (s, i) { s.classList.toggle('piranga-off', !flags[i]); });
      twoUp(group);
      filterZoom(host, flags);
      // a new colour starts from its first photo, wherever the page was scrolled to
      var top = group.getBoundingClientRect().top;
      if (!first && top < 0) window.scrollTo(0, window.pageYOffset + top);
    }
    apply();
    onColourChange(colours, apply);
    window.addEventListener('load', apply);   // the colour can be settled after this script first ran
  }

  // desktop: the details stay beside the photos; a column taller than the screen scrolls to its end first
  function initStickyDetails() {
    if (!document.documentElement.classList.contains('piranga-stack-gallery')) return;
    var details = $('.main_pro_class .product-single__metas');
    if (!details || details.getAttribute('data-pi-stick')) return;
    details.setAttribute('data-pi-stick', '1');
    function place() { details.style.top = Math.min(0, window.innerHeight - details.offsetHeight) + 'px'; }
    place();
    window.addEventListener('resize', place);
    if ('ResizeObserver' in window) new ResizeObserver(place).observe(details);
  }

  /* ---------- gallery meta (1 / N, caption, expand) ---------- */
  function initGallery() {
    if (!document.documentElement.classList.contains('piranga-native-gallery')) return;
    var group = $('.main_pro_class .js-product-media-group');
    if (!group || group.getAttribute('data-pi-meta')) return;
    var items = group.querySelectorAll('.js-product-media-item');
    var all = Array.prototype.slice.call(items);
    var active = all.slice();               // the photos on show: the selected colour's
    var n = active.length;
    var colours = photoColours();
    group.setAttribute('data-pi-meta', '1');
    var host = group.closest('.product-single__main-media') || group.parentElement;
    var capSrc = group.closest('.js-product-single-media');
    var caption = capSrc ? (capSrc.getAttribute('data-piranga-caption') || '').trim() : '';

    var meta = document.createElement('div');
    meta.className = 'piranga-gallery-meta';
    meta.innerHTML =
      (n > 1 ? '<span class="piranga-gallery-count">1 / ' + n + '</span>' : '') +
      (caption ? '<span class="piranga-gallery-caption"></span>' : '') +
      '<button type="button" class="piranga-gallery-expand" aria-label="Expand image">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><path d="M10 1h5v5M6 15H1v-5"/></svg></button>';
    host.appendChild(meta);
    if (caption) meta.querySelector('.piranga-gallery-caption').textContent = caption;

    var count = meta.querySelector('.piranga-gallery-count');
    var cur = 0, settle = 0, applied = null, started = false;

    // loop: a copy of the last photo sits before the first and a copy of the first after the last; once a swipe lands on a copy, jump to the real photo.
    // The gallery moves by transform rather than native scrolling: iOS ignores scroll position changes while a swipe glides, which left it stuck on a copy.
    var loop = false, offset = 0;
    function copySlide(item) {
      var copy = item.cloneNode(true);
      copy.className = 'piranga-clone' + (item.classList.contains('piranga-photo-cover') ? ' piranga-photo-cover' : '');
      copy.setAttribute('aria-hidden', 'true');
      copy.querySelectorAll('[id],[data-media-id]').forEach(function (el) { el.removeAttribute('id'); el.removeAttribute('data-media-id'); });
      copy.querySelectorAll('img').forEach(function (img) { img.className = ''; img.removeAttribute('fetchpriority'); img.loading = 'eager'; });
      return copy;
    }
    var head = null, tail = null;
    function setLoop() {
      if (head) { head.parentNode.removeChild(head); tail.parentNode.removeChild(tail); head = tail = null; }
      loop = n > 1 && !group.querySelector('video,iframe,model-viewer');
      offset = loop ? 1 : 0;
      if (!loop) return;
      head = copySlide(active[n - 1]);
      tail = copySlide(active[0]);
      group.insertBefore(head, group.firstChild);
      group.appendChild(tail);
    }
    function frameWidth() { return group.parentElement.clientWidth || group.clientWidth || 1; }
    function place(x, ms) {
      group.style.setProperty('transition', ms ? 'transform ' + ms + 'ms cubic-bezier(.22,.7,.3,1)' : 'none', 'important');
      if (!ms) void group.offsetWidth;
      group.style.setProperty('transform', 'translate3d(' + x + 'px,0,0)', 'important');
      if (!ms) void group.offsetWidth;
    }
    function currentX() {
      var m = getComputedStyle(group).transform.match(/matrix(3d)?\(([^)]+)\)/);
      if (!m) return 0;
      var v = m[2].split(',');
      return parseFloat(m[1] ? v[12] : v[4]) || 0;
    }
    // photos around the one on show load early, so a swipe never reveals a blank frame
    function warm() {
      [cur - 1, cur, cur + 1].forEach(function (i) {
        var img = active[(i + n) % n] && active[(i + n) % n].querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      });
    }
    function setCount() {
      if (!count) return;
      count.textContent = (cur + 1) + ' / ' + n;
      count.style.display = n > 1 ? '' : 'none';
    }
    function show(i) {
      clearTimeout(settle);
      cur = i;
      place(-(i + offset) * frameWidth(), 0);
      setCount();
      warm();
    }
    // i may be -1 or n: the copies either side of the real photos
    function glide(i) {
      var w = frameWidth();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      clearTimeout(settle);
      cur = (i + n) % n;
      place(-(i + offset) * w, reduce ? 0 : 300);
      setCount();
      warm();
      settle = setTimeout(function () { place(-(cur + offset) * frameWidth(), 0); }, reduce ? 0 : 320);
    }
    function applyColour() {
      var colour = colours && selectedColour(colours);
      if (started && colour === applied) return;   // nothing changed: a late call (page load) must not reset a swipe in progress
      started = true;
      applied = colour;
      if (colour) {
        var flags = colourFlags(colours, all, colour);
        active = all.filter(function (item, i) { return flags[i]; });
        n = active.length;
        all.forEach(function (item, i) { item.classList.toggle('piranga-off', !flags[i]); });
        filterZoom(host, flags);
      }
      setLoop();
      show(0);
    }
    applyColour();
    if (colours) onColourChange(colours, applyColour);
    var lastWidth = frameWidth();
    window.addEventListener('resize', function () {
      if (frameWidth() === lastWidth) return;
      lastWidth = frameWidth();
      show(cur);
    });

    // swipe: follows the finger, and a new swipe can start at any moment, even mid-glide
    var dragId = null, startX = 0, startY = 0, startTime = 0, base = 0, baseIndex = 0, sideways = false, moved = false;
    group.addEventListener('pointerdown', function (e) {
      moved = false;
      if (n < 2 || (e.pointerType === 'mouse' && e.button !== 0)) return;
      var w = frameWidth(), x = currentX();
      clearTimeout(settle);
      // mid-glide the gallery may still be on a copy: shift by a whole set of photos so this swipe carries on from the current photo
      if (loop) x += Math.round((-(cur + offset) * w - x) / (n * w)) * n * w;
      place(x, 0);
      dragId = e.pointerId; startX = e.clientX; startY = e.clientY; startTime = Date.now();
      base = x; baseIndex = cur; sideways = false;
    });
    group.addEventListener('pointermove', function (e) {
      if (e.pointerId !== dragId) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (!sideways) {
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { moved = true; dragId = null; glide(baseIndex); return; }
        if (Math.abs(dx) < 8) return;
        sideways = true; moved = true;
        try { group.setPointerCapture(e.pointerId); } catch (err) {}
      }
      var atEdge = !loop && ((baseIndex === 0 && dx > 0) || (baseIndex === n - 1 && dx < 0));
      place(base + (atEdge ? dx * 0.3 : dx), 0);
    });
    function endDrag(e) {
      if (e.pointerId !== dragId) return;
      dragId = null;
      if (!sideways) { glide(baseIndex); return; }
      var dx = e.clientX - startX, speed = Math.abs(dx) / Math.max(1, Date.now() - startTime);
      var target = baseIndex;
      if (e.type === 'pointerup' && (Math.abs(dx) > frameWidth() * 0.15 || speed > 0.35)) target = baseIndex + (dx < 0 ? 1 : -1);
      glide(loop ? target : Math.max(0, Math.min(n - 1, target)));
    }
    group.addEventListener('pointerup', endDrag);
    group.addEventListener('pointercancel', endDrag);

    // tall frame: a photo with a plain background stays whole and the frame takes that background colour; a textured photo fills the frame instead
    function edge(ctx, y, width) {
      var d = ctx.getImageData(0, y, width, 1).data;
      var min = [255, 255, 255], max = [0, 0, 0], sum = [0, 0, 0], clear = false;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 250) clear = true;
        for (var c = 0; c < 3; c++) {
          min[c] = Math.min(min[c], d[i + c]);
          max[c] = Math.max(max[c], d[i + c]);
          sum[c] += d[i + c];
        }
      }
      return {
        clear: clear,
        spread: Math.max(max[0] - min[0], max[1] - min[1], max[2] - min[2]),
        rgb: 'rgb(' + sum.map(function (v) { return Math.round(v / width); }).join(',') + ')'
      };
    }
    function fitPhoto(item) {
      var img = item.querySelector('img');
      if (!img) return;
      function fit() {
        if (!img.naturalWidth) return;
        var targets = [item];
        if (tail && item === active[0]) targets.push(tail);
        if (head && item === active[n - 1]) targets.push(head);
        try {
          var canvas = document.createElement('canvas');
          canvas.width = 24; canvas.height = 30;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, 24, 30);
          var top = edge(ctx, 0, 24), bottom = edge(ctx, 29, 24);
          if (top.clear || bottom.clear) return;
          targets.forEach(function (t) {
            if (top.spread > 14 || bottom.spread > 14) t.classList.add('piranga-photo-cover');
            else t.style.background = 'linear-gradient(to bottom,' + top.rgb + ' 50%,' + bottom.rgb + ' 50%)';
          });
        } catch (e) {}
      }
      if (img.complete) fit(); else img.addEventListener('load', fit, { once: true });
    }
    all.forEach(fitPhoto);

    // tap (not drag) on a photo -> full-screen viewer at that photo
    group.addEventListener('click', function (e) {
      if (moved) return;
      var item = e.target.closest('.js-product-media-item');
      if (!item || e.target.closest('video,a,button')) return;
      var zd = host.querySelector('zoom-dialog');
      var dlg = zd && zd.querySelector('dialog');
      if (dlg && dlg.open) return;                         // the theme's own handler already opened it
      if (zd && typeof zd.open === 'function') zd.open(Array.prototype.indexOf.call(items, item));
    });

    meta.querySelector('.piranga-gallery-expand').addEventListener('click', function (ev) {
      ev.preventDefault(); ev.stopPropagation();
      var zd = host.querySelector('zoom-dialog');
      if (zd && typeof zd.open === 'function') zd.open(all.indexOf(active[cur]));
    });

    // colour / variant change -> jump the gallery to that variant's photo (a smooth scroll can be dropped while scroll-snap is active)
    function showVariant(v) {
      if (!v || !v.featured_media) return;
      var el = group.querySelector('[data-media-id$="-' + v.featured_media.id + '"]');
      var item = el && el.closest('.js-product-media-item');
      var idx = item ? active.indexOf(item) : -1;
      if (idx >= 0) show(idx);
    }
    function bindVariant() {
      if (!window.jQuery || group.getAttribute('data-pi-var')) return;
      group.setAttribute('data-pi-var', '1');
      window.jQuery(document).on('variantMediaChange', function (e) { showVariant(e.variant); });
    }
    bindVariant();
    window.addEventListener('load', function () {
      bindVariant();
      applyColour();                        // the colour can be settled after this script first ran
      // a link that already names a variant opens on that colour's photo
      var m = location.search.match(/[?&]variant=(\d+)/);
      var pj = $('script[id^="ProductJson-"]');
      if (!m || !pj) return;
      try {
        JSON.parse(pj.textContent).variants.forEach(function (v) { if (String(v.id) === m[1]) showVariant(v); });
      } catch (e) {}
    });
  }

  /* ---------- sticky Add to Cart (appears after the main button scrolls out of view) ---------- */
  function initSticky() {
    var main = $('.main_pro_class .product-single__add-to-cart button[name="add"]');
    if (!main || $('.piranga-sticky-atc')) return;
    var bar = document.createElement('div');
    bar.className = 'piranga-sticky-atc';
    bar.innerHTML = '<button type="button" class="piranga-sticky-atc__btn"><span></span></button>';
    document.body.appendChild(bar);
    var btn = bar.querySelector('button'), label = bar.querySelector('span');

    function text() {
      var t = main.querySelector('.btn__text');
      label.textContent = ((t ? t.textContent : main.textContent) || '').trim() || 'Add to cart';
      btn.disabled = !!main.disabled;
    }
    text();
    new MutationObserver(text).observe(main, { childList: true, subtree: true, characterData: true, attributes: true });

    function set(on) { bar.classList.toggle('is-on', !!on && mq.matches); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        set(!e.isIntersecting && e.boundingClientRect.top < 0);   // only after scrolling PAST it, gone again when it is back in view
      }, { threshold: 0 }).observe(main);
    } else {
      window.addEventListener('scroll', function () { set(main.getBoundingClientRect().bottom < 0); }, { passive: true });
    }
    btn.addEventListener('click', function () {
      var pending = main.form && main.form.classList.contains('piranga-size-pending');
      main.click();   // same size-check + add-to-cart flow as the main button
      if (!pending) return;
      btn.setAttribute('data-pi-label', label.textContent);
      btn.classList.remove('piranga-slide');
      void btn.offsetWidth;
      btn.classList.add('piranga-slide');
      clearTimeout(btn._piSlide);
      btn._piSlide = setTimeout(function () { btn.classList.remove('piranga-slide'); }, 300);
    });
  }

  /* ---------- feature video: plays on a silent loop while on screen, pauses when scrolled away ---------- */
  function initFeatureVideo() {
    document.querySelectorAll('.product-feature-video__media video').forEach(function (video) {
      if (video.getAttribute('data-pi-video')) return;
      video.setAttribute('data-pi-video', '1');
      video.muted = true; video.loop = true; video.playsInline = true;
      video.setAttribute('playsinline', '');
      function play() { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
      if (!('IntersectionObserver' in window)) { play(); return; }
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) play(); else video.pause();
      }, { threshold: 0.2 }).observe(video);
    });
  }

  /* ---------- header turns see-through once the page scrolls ---------- */
  function initHeader() {
    var root = document.documentElement;
    if (root.getAttribute('data-pi-header')) return;
    root.setAttribute('data-pi-header', '1');
    function set() { root.classList.toggle('piranga-scrolled', window.pageYOffset > 10); }
    set();
    window.addEventListener('scroll', set, { passive: true });
  }

  /* ---------- collection: six rows at a time. A page of products fills six rows on desktop; with fewer products to a row the rest wait behind Load more ---------- */
  function initCollectionRows() {
    var root = $('#JsCollectionProduct');
    if (!root || root.getAttribute('data-pi-rows')) return;
    root.setAttribute('data-pi-rows', '1');
    var shown = 0, last = 0;
    function perLoad(items) {
      var row = items[0].parentElement;
      return Math.max(1, Math.round(row.clientWidth / (items[0].offsetWidth || 1))) * 6;
    }
    function apply() {
      var items = Array.prototype.slice.call(root.querySelectorAll('.products__col'));
      if (!items.length) return;
      if (items.length < last) shown = 0;       // a filter replaced the grid
      last = items.length;
      if (!shown) shown = perLoad(items);
      items.forEach(function (item, i) { item.classList.toggle('piranga-row-off', i >= shown); });
      var waiting = items.length > shown;
      var footer = $('.js-collection-loadmore', root);
      if (!footer) return;
      var extra = $('[data-pi-more]', footer);
      if (waiting && !$('a', footer)) footer.insertAdjacentHTML('beforeend', '<a href="#" data-pi-more>Load more</a>');
      if (!waiting && extra) footer.removeChild(extra);
      var count = $('.collection-product-count', footer);
      var bar = $('.percent', footer);
      var total = count && count.textContent.match(/\d+/g);
      if (total && total.length > 1) {
        var seen = Math.min(shown, items.length);
        var text = count.textContent.replace(/\d+/, seen);
        if (text !== count.textContent) count.textContent = text;
        if (bar) bar.style.width = Math.min(100, seen * 100 / Number(total[1])) + '%';
      }
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.js-collection-loadmore a')) return;
      var items = root.querySelectorAll('.products__col');
      var step = items.length ? perLoad(Array.prototype.slice.call(items)) : 0;
      if (root.querySelector('.piranga-row-off')) {
        e.preventDefault(); e.stopPropagation();
        shown += step;
        apply();
      } else {
        shown += step;
      }
    }, true);
    apply();
    new MutationObserver(apply).observe(root, { childList: true, subtree: true });
  }

  // Home page videos: download only when near the screen, and pause when scrolled away.
  function initLazyVideos() {
    var vids = document.querySelectorAll('video[data-pi-video]:not([data-pi-ready])');
    if (!vids.length) return;
    function load(v) { if (!v.src) { v.src = v.getAttribute('data-pi-video'); } var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    if (!('IntersectionObserver' in window)) { vids.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) load(e.target); else if (e.target.src) e.target.pause(); });
    }, { rootMargin: '400px 0px' });
    vids.forEach(function (v) { v.setAttribute('data-pi-ready', ''); io.observe(v); });
  }
  /* ---------- full-screen photo viewer on phones: swipes loop round like the gallery ---------- */
  // The viewer used to scroll natively, which stops at the last photo. Here it moves by transform with a copy of the
  // last photo before the first and of the first after the last, the same way the gallery does.
  function initZoomLoop() {
    if (!document.documentElement.classList.contains('piranga-native-gallery') || window.innerWidth >= 750) return;
    $$('zoom-dialog').forEach(function (zd) {
      if (zd.getAttribute('data-pi-loop')) return;
      var dialog = zd.querySelector('dialog'), wrap = zd.querySelector('.media-dialog');
      if (!dialog || !wrap) return;
      zd.setAttribute('data-pi-loop', '1');
      zd.classList.add('piranga-zoom-loop');
      var real = [], n = 0, cur = 0, settle = 0, head = null, tail = null;

      function width() { return wrap.parentElement.clientWidth || window.innerWidth; }
      function place(x, ms) {
        wrap.style.setProperty('transition', ms ? 'transform ' + ms + 'ms cubic-bezier(.22,.7,.3,1)' : 'none', 'important');
        if (!ms) void wrap.offsetWidth;
        wrap.style.setProperty('transform', 'translate3d(' + x + 'px,0,0)', 'important');
        if (!ms) void wrap.offsetWidth;
      }
      function currentX() {
        var m = getComputedStyle(wrap).transform.match(/matrix(3d)?\(([^)]+)\)/);
        if (!m) return 0;
        var v = m[2].split(',');
        return parseFloat(m[1] ? v[12] : v[4]) || 0;
      }
      function copy(item) {
        var c = item.cloneNode(true);
        c.classList.add('piranga-clone');
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
        return c;
      }
      function warm() {
        [cur - 1, cur, cur + 1].forEach(function (i) {
          var img = real[(i + n) % n] && real[(i + n) % n].querySelector('img');
          if (img && img.loading === 'lazy') img.loading = 'eager';
        });
      }
      function mark() {
        var all = zd.refs ? zd.refs.media : [];
        var at = all.indexOf(real[cur]);
        Array.prototype.forEach.call(zd.refs ? zd.refs.thumbnails : [], function (btn, i) { btn.setAttribute('aria-selected', i === at); });
      }
      // the photos on show are the selected colour's, so the loop is built each time the viewer opens
      function build() {
        if (head) { wrap.removeChild(head); wrap.removeChild(tail); head = tail = null; }
        real = Array.prototype.filter.call(wrap.querySelectorAll('.product-media-container'), function (el) {
          return !el.classList.contains('piranga-off') && !el.classList.contains('piranga-clone');
        });
        n = real.length;
        if (n > 1) {
          head = copy(real[n - 1]); tail = copy(real[0]);
          wrap.insertBefore(head, wrap.firstChild); wrap.appendChild(tail);
        }
      }
      function offset() { return n > 1 ? 1 : 0; }
      function show(i) {
        clearTimeout(settle);
        cur = Math.max(0, Math.min(n - 1, i));
        place(-(cur + offset()) * width(), 0);
        warm(); mark();
      }
      // i may be -1 or n: the copies either side of the real photos
      function glide(i) {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        clearTimeout(settle);
        cur = (i + n) % n;
        place(-(i + offset()) * width(), reduce ? 0 : 300);
        warm(); mark();
        settle = setTimeout(function () { place(-(cur + offset()) * width(), 0); }, reduce ? 0 : 320);
      }

      // the theme opens the viewer by scrolling to a photo; here it goes to that photo in the loop instead
      zd.open = function (index) {
        build();
        document.body.style.overflow = 'hidden';
        if (!dialog.open) dialog.showModal();
        lastW = width();
        var target = (zd.refs && zd.refs.media[index]) || real[0];
        show(Math.max(0, real.indexOf(target)));
      };
      zd.selectThumbnail = function (index) {
        var target = zd.refs && zd.refs.media[index];
        if (target && real.indexOf(target) >= 0) glide(real.indexOf(target));
      };
      var lastW = 0;   // the phone's address bar showing or hiding fires resize too; only a real width change moves the photo
      window.addEventListener('resize', function () { if (dialog.open && width() !== lastW) { lastW = width(); show(cur); } });

      // one finger swipes; two fingers are left to the browser for pinch zoom
      var fingers = 0, dragId = null, startX = 0, startY = 0, startTime = 0, base = 0, baseIndex = 0, sideways = false;
      wrap.addEventListener('pointerdown', function (e) {
        fingers++;
        if (fingers > 1) { if (dragId !== null) { dragId = null; glide(baseIndex); } return; }
        if (n < 2) return;
        var w = width(), x = currentX();
        clearTimeout(settle);
        x += Math.round((-(cur + offset()) * w - x) / (n * w)) * n * w;   // mid-glide on a copy: carry on from the real photo
        place(x, 0);
        dragId = e.pointerId; startX = e.clientX; startY = e.clientY; startTime = Date.now();
        base = x; baseIndex = cur; sideways = false;
      });
      wrap.addEventListener('pointermove', function (e) {
        if (e.pointerId !== dragId) return;
        var dx = e.clientX - startX, dy = e.clientY - startY;
        if (!sideways) {
          if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { dragId = null; glide(baseIndex); return; }
          if (Math.abs(dx) < 8) return;
          sideways = true;
          try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
        }
        place(base + dx, 0);
      });
      function end(e) {
        fingers = Math.max(0, fingers - 1);
        if (e.pointerId !== dragId) return;
        dragId = null;
        if (!sideways) { glide(baseIndex); return; }
        var dx = e.clientX - startX, speed = Math.abs(dx) / Math.max(1, Date.now() - startTime);
        var target = baseIndex;
        if (e.type === 'pointerup' && (Math.abs(dx) > width() * 0.15 || speed > 0.35)) target = baseIndex + (dx < 0 ? 1 : -1);
        glide(target);
      }
      wrap.addEventListener('pointerup', end);
      wrap.addEventListener('pointercancel', end);
      dialog.addEventListener('close', function () { fingers = 0; dragId = null; });
    });
  }

  function start() { initGallery(); initDesktopColours(); initStickyDetails(); initSticky(); initFeatureVideo(); initHeader(); initCollectionRows(); initLazyVideos(); initZoomLoop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
